export enum FuneralPlanTab {
  PREVENT = 'PREVENT',
  LOST_SOMEONE = 'LOST_SOMEONE'
}
